// Version : 0.0.1
// Author : Vignesh

const CashTransactionTypes = {
	/*** ADD CASH TRANSACTION DETAILS START ***/
	ADD_CASH_TRANSACTION_DETAILS_START: 'add_cash_transaction_details_start',
	ADD_CASH_TRANSACTION_DETAILS_SUCCESS: 'add_cash_transaction_details_success',
	ADD_CASH_TRANSACTION_DETAILS_FAILURE: 'add_cash_transaction_details_failure',
	ADD_CASH_TRANSACTION_DETAILS_RESPONSE_RESET: 'add_cash_transaction_details_response_reset',
	ADD_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED: 'add_cash_transaction_details_response_changed',
	/*** ADD CASH TRANSACTION DETAILS END ***/

	// /*** GET CASH TRANSACTION LIST START ***/
	GET_CASH_TRANSACTION_LIST_START: 'get_cash_transaction_list_start',
	GET_CASH_TRANSACTION_LIST_SUCCESS: 'get_cash_transaction_list_success',
	GET_CASH_TRANSACTION_LIST_FAILURE: 'get_cash_transaction_list_failure',
	GET_CASH_TRANSACTION_LIST_RESPONSE_RESET: 'get_cash_transaction_list_response_reset',
	GET_CASH_TRANSACTION_LIST_RESPONSE_CHANGED: 'get_cash_transaction_list_response_changed',
	// /*** GET CASH TRANSACTION LIST END ***/

	/*** GET COMPANY FINANCE ACCOUNT TYPE LIST START ***/
	GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_START: 'get_company_finance_account_type_list_start',
	GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_SUCCESS: 'get_company_finance_account_type_list_success',
	GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_FAILURE: 'get_company_finance_account_type_list_failure',
	GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_RESET:
		'get_company_finance_account_type_list_response_reset',
	GET_COMPANY_FINANCE_ACCOUNT_TYPE_LIST_RESPONSE_CHANGED:
		'get_company_finance_account_type_list_response_changed',
	/*** GET COMPANY FINANCE ACCOUNT TYPE LIST END ***/

	/*** GET ACCOUNT DAY LIST START ***/
	GET_ACCOUNT_DAY_BOOK_LIST_START: 'get_account_day_book_list_start',
	GET_ACCOUNT_DAY_BOOK_LIST_SUCCESS: 'get_account_day_book_list_success',
	GET_ACCOUNT_DAY_BOOK_LIST_FAILURE: 'get_account_day_book_list_failure',
	GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_RESET: 'get_account_day_book_list_response_reset',
	GET_ACCOUNT_DAY_BOOK_LIST_RESPONSE_CHANGED: 'get_account_day_book_list_response_changed',
	/*** GET ACCOUNT DAY LIST START ***/

	/*** GET ACCOUNT DAY BOOK FOR ACCOUNT START ***/
	GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_START: 'get_account_day_book_for_account_start',
	GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_SUCCESS: 'get_account_day_book_for_account_success',
	GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_FAILURE: 'get_account_day_book_for_account_failure',
	GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_RESET:
		'get_account_day_book_for_account_response_reset',
	GET_ACCOUNT_DAY_BOOK_FOR_ACCOUNT_RESPONSE_CHANGED:
		'get_account_day_book_for_account_response_changed',
	/*** GET ACCOUNT DAY BOOK FOR ACCOUNT END ***/

	/*** GET VOUCHER COUNT BASED ON COMPANY START ***/
	GET_VOUCHER_COUNT_BASED_ON_COMPANY_START: 'get_voucher_count_based_on_company_start',
	GET_VOUCHER_COUNT_BASED_ON_COMPANY_SUCCESS: 'get_voucher_count_based_on_company_success',
	GET_VOUCHER_COUNT_BASED_ON_COMPANY_FAILURE: 'get_voucher_count_based_on_company_failure',
	GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_RESET:
		'get_voucher_count_based_on_company_response_reset',
	GET_VOUCHER_COUNT_BASED_ON_COMPANY_RESPONSE_CHANGED:
		'get_voucher_count_based_on_company_response_changed',
	/*** GET VOUCHER COUNT BASED ON COMPANY END ***/

	/*** CHECK BRANCH EOD DONE START ***/
	CHECK_BRANCH_EOD_DONE_START: 'check_branch_eod_done_start',
	CHECK_BRANCH_EOD_DONE_SUCCESS: 'check_branch_eod_done_success',
	CHECK_BRANCH_EOD_DONE_FAILURE: 'check_branch_eod_done_failure',
	CHECK_BRANCH_EOD_DONE_RESPONSE_RESET: 'check_branch_eod_done_response_reset',
	CHECK_BRANCH_EOD_DONE_RESPONSE_CHANGED: 'check_branch_eod_done_response_changed',
	/*** CHECK BRANCH EOD DONE END ***/

	/*** UPDATE CASH TRANSACTION DETAILS START ***/
	UPDATE_CASH_TRANSACTION_DETAILS_START: 'update_cash_transaction_details_start',
	UPDATE_CASH_TRANSACTION_DETAILS_SUCCESS: 'update_cash_transaction_details_success',
	UPDATE_CASH_TRANSACTION_DETAILS_FAILURE: 'update_cash_transaction_details_failure',
	UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET:
		'update_cash_transaction_details_response_reset',
	UPDATE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'update_cash_transaction_details_response_changed',
	/*** UPDATE CASH TRANSACTION DETAILS END ***/

	/*** GET PARTICULAR CASH TRANSACTION DETAILS START ***/
	FETCH_CASH_TRANSACTION_DETAILS_START: 'fetch_cash_transaction_details_start',
	FETCH_CASH_TRANSACTION_DETAILS_SUCCESS: 'fetch_cash_transaction_details_success',
	FETCH_CASH_TRANSACTION_DETAILS_FAILURE: 'fetch_cash_transaction_details_failure',
	FETCH_CASH_TRANSACTION_DETAILS_RESPONSE_RESET: 'fetch_cash_transaction_details_response_reset',
	FETCH_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'fetch_cash_transaction_details_response_changed',
	/*** GET PARTICULAR CASH TRANSACTION DETAILS END ***/

	/*** DELETE CASH TRANSACTION DETAILS START ***/
	DELETE_CASH_TRANSACTION_DETAILS_START: 'delete_cash_transaction_details_start',
	DELETE_CASH_TRANSACTION_DETAILS_SUCCESS: 'delete_cash_transaction_details_success',
	DELETE_CASH_TRANSACTION_DETAILS_FAILURE: 'delete_cash_transaction_details_failure',
	DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_RESET:
		'delete_cash_transaction_details_response_reset',
	DELETE_CASH_TRANSACTION_DETAILS_RESPONSE_CHANGED:
		'delete_cash_transaction_details_response_changed',
	/*** DELETE CASH TRANSACTION DETAILS END ***/

	/*** GET PARTICULAR CASH TRANSACTION LIST START ***/
	GET_PARTICULAR_CASH_TRANSACTION_LIST_START: 'get_particular_cash_transaction_list_start',
	GET_PARTICULAR_CASH_TRANSACTION_LIST_SUCCESS: 'get_particular_cash_transaction_list_success',
	GET_PARTICULAR_CASH_TRANSACTION_LIST_FAILURE: 'get_particular_cash_transaction_list_failure',
	GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_RESET:
		'get_particular_cash_transaction_list_response_reset',
	GET_PARTICULAR_CASH_TRANSACTION_LIST_RESPONSE_CHANGED:
		'get_particular_cash_transaction_list_response_changed',
	/*** GET PARTICULAR CASH TRANSACTION LIST END ***/

	// /*** UPDATE SELECTED TRANSACTION IS_APPROVE START ***/
	UPDATE_SELECTED_TRANSACTION_IS_APPROVE_START: 'update_selected_transaction_is_approve_start',
	UPDATE_SELECTED_TRANSACTION_IS_APPROVE_SUCCESS:
		'update_selected_transaction_is_approve_success',
	UPDATE_SELECTED_TRANSACTION_IS_APPROVE_FAILURE:
		'update_selected_transaction_is_approve_failure',
	UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_RESET:
		'update_selected_transaction_is_approve_response_reset',
	UPDATE_SELECTED_TRANSACTION_IS_APPROVE_RESPONSE_CHANGED:
		'update_selected_transaction_is_approve_response_changed',
	// /*** UPDATE SELECTED TRANSACTION IS_APPROVE END ***/

	/*** GET VALUES MODAL START ***/
	GET_VALUES_MODAL_START: 'get_values_modal_start',
	GET_VALUES_MODAL_SUCCESS: 'get_values_modal_success',
	GET_VALUES_MODAL_FAILURE: 'get_values_modal_failure',
	GET_VALUES_MODAL_RESPONSE_RESET: 'get_values_modal_response_reset',
	GET_VALUES_MODAL_RESPONSE_CHANGED: 'get_values_modal_response_changed',
	/*** GET VALUES MODAL END ***/
};

export default CashTransactionTypes;
